import URL from 'url';
import _ from 'lodash';
import QueryString from "qs";


class UrlHelper
{
    static getPackageViewUrl( packageName, type = null, channel = null, signature = null )
    {
        const query     = _.omitBy( { type, channel, signature }, _.isNull ),
            pathname    = `/package/${ encodeURIComponent( packageName ) }`;

        return URL.format( { query, pathname } );
    }


    static getPackageListUrl( packageFilter = null, type = null, channel = null, signature = null )
    {
        const query     = _.omitBy( { packageFilter, type, channel, signature }, _.isNull ),
            pathname    = `/packages`;

        return URL.format( { query, pathname } );
    }


    static getDocListUrl( packageFilter = null, type = null, channel = null, signature = null )
    {
        const query     = _.omitBy( { packageFilter, type, channel, signature }, _.isNull ),
            pathname    = `/docs`;

        return URL.format( { query, pathname } );
    }


    static getDocViewUrl( packageName, type = null, channel = null, signature = null )
    {
        const query     = _.omitBy( { type, channel, signature }, _.isNull ),
            pathname    = `/doc/${ encodeURIComponent( packageName ) }`;

        return URL.format( { query, pathname } );
    }


    static getNPMUrl( packageName )
    {
        if( packageName.substr( 0, 6 ) === '@r3pi/' )
        {
            return `https://npm.r3pi.net/package/${packageName}`;
        }

        return `https://www.npmjs.com/package/${packageName}`;
    }


    static getBitbucketRepoUrl( report, branchName = null )
    {
        return `${report.data.pkg.repoWebUrl}/browse${branchName ? '?at=refs%2Fheads%2F' + encodeURIComponent( branchName ) : ''}` ;
    }


    static getBitbucketCommitUrl( report, commit )
    {
        return `${report.data.pkg.repoWebUrl}/commits/${commit}`;
    }


    static getMicroserviceBaseUrl( packageName, env = 'dg2-dev-empire' )
    {
        return `http://${UrlHelper.getMicroserviceBaseHost( packageName, env)}/`;
    }


    static getMicroserviceBaseHost( packageName, env = 'dg2-dev-empire' )
    {
        const shortName = packageName.replace( /^@.*\//, '' );

        return `${shortName}.${env}`;
    }


    static getLocalSearchParams( searchString )
    {
        return QueryString.parse( searchString, { ignoreQueryPrefix: true } );
    }
}

export default UrlHelper;




// WEBPACK FOOTER //
// ./src/lib/url-helper.js